export default "/images/vendor/flag-icons/flags/1x1/li.svg?62ec4ab052a970be5f948f5cab48c830";